<template>
  <div>
    <div class="info" v-if="showInfo">
      To combat spam, please click the verify button. This site uses reCAPTCHA v3 to verify users.
    </div>
    <div class="contact-container min-h-screen flex flex-col items-center justify-center fade-in">
      <div class="text-center bg-white bg-opacity-100 p-8 rounded-lg shadow-lg">
        <h1 class="text-4xl font-bold text-gray-800 mb-4">Contact Information</h1>
        <p class="text-xl text-gray-600 mb-6"></p>
        <div v-if="verified" class="space-y-4">
          <div>
            <p class="text-lg text-gray-700">Email:</p>
            <a href="mailto:jelliot.stocker@gmail.com" class="text-blue-500 hover:underline group">
              <span class="group-hover:animate-pulse">jelliot.stocker@gmail.com</span>
            </a>
          </div>
          <div>
            <p class="text-lg text-gray-700">Phone:</p>
            <a href="tel:+8049722216" class="text-blue-500 hover:underline group">
              <span class="group-hover:animate-pulse">+1 (804) 972-2216</span>
            </a>
          </div>
        </div>
        <div v-else>
          <button @click="executeRecaptcha" class="bg-blue-500 text-white px-4 py-2 rounded">Verify</button>
        </div>
        <div>
          <p class="text-lg text-gray-700 privacy-policy">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <br />
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      verified: false,
      showInfo: true,
      siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY // Use the environment variable
    };
  },
  methods: {
    executeRecaptcha() {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(this.siteKey, { action: 'submit' }).then((token) => {
          this.onVerify(token);
        });
      });
    },
    onVerify() {
      // Here you would typically send the token to your server for verification
      this.verified = true;
      this.showInfo = false;
    }
  },
  // Uncomment the following code to check the site key in console.
  // mounted() {
    // console.log('Site Key:', this.siteKey); // Add this line to check the site key
  // }
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-in {
  animation: fadeIn 1s ease-in;
}

.contact-container { /* Optional alternate background image */
  /* background-image: url('@/assets/') */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.info {
  color: gray;
  justify-content: center;
  display: flex;
  position: absolute;
  top: 0;
  width: 100%; 
  padding: 10rem;
  text-align: center;
}

.privacy-policy {
  margin-top: 10px;
  font-size: 0.8rem;
  color: gray;
}

.privacy-policy a {
  color: #544ac7;
}

@media (max-width: 600px) {
  .info {
    font-size: 14px;
    padding: 5px;
    word-wrap: break-word;
    margin-top: 3rem;
  }
}
</style>